var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.path =='/menu')?_c('v-navigation-drawer',{staticClass:"orderDrawerStyle",attrs:{"temporary":"","fixed":"","right":""},model:{value:(_vm.OrderDrawer),callback:function ($$v) {_vm.OrderDrawer=$$v},expression:"OrderDrawer"}},[_c('div',{staticClass:"drawer-container orderdrawerBackground"},[_c('order-drawer-order')],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }